export type CommuteMode =
  | "tube"
  | "bus"
  | "walk"
  | "cycle"
  | "drive"
  | "mixed";

const FARE_PER_LEG: Record<CommuteMode, number> = {
  tube: 4.2,
  bus: 1.75,
  walk: 0,
  cycle: 0,
  drive: 6.5,
  mixed: 3.5,
};

const WEEKS_PER_MONTH = 4.33;

export function estimateCommuteCost(
  mode: CommuteMode,
  daysPerWeek: number
): { monthlyMin: number; monthlyMax: number; perTrip: number } {
  const days = Math.max(0, Math.min(5, daysPerWeek));
  const perTrip = FARE_PER_LEG[mode];
  const dailyReturn = perTrip * 2;
  const weekly = dailyReturn * days;
  const monthly = weekly * WEEKS_PER_MONTH;
  const variance = mode === "tube" || mode === "mixed" ? 0.15 : 0.05;
  return {
    perTrip,
    monthlyMin: Math.round(monthly * (1 - variance)),
    monthlyMax: Math.round(monthly * (1 + variance)),
  };
}
